// Default Personality Traits English
const defaultPersonalityTraits_en = [
  {
    title: "Big Picture Thinker",
    tagline: "Intuitive, cognitive and caters to a broader perspective.",
    ability: "Thinking Big",
    description:
      "Shifting focus away from the details and gain a broader perspective; envisioning future scenarios based on a combination of intuition, trends and data; dealing with complex intellectual and cognitive concepts.",
    iAmDescription:
      "I am a Big Picture Thinker with an intuitive and cognitive mind that caters to a broader perspective. Exceptionally capable in organising and running activities and projects.",
    icon: require("@/assets/images/icons/personality-icons/Big Picture Thinker.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Big Picture Thinker.png"),
    id: "big-picture-thinker",
    personalityMapId: 6,
  },
  {
    title: "Calming Influence",
    tagline: "Elegant. Patient, humble and calm under pressure",
    ability: "Calming Influence",
    description:
      "Remaining calm under pressure; recognizing the contribution of others and acts humbly about strengths and achievements; being patient with people and knowing when to slow down to let others catch up; balancing work and personal priorities.",
    iAmDescription:
      "Calming Influence in the midst of a highly energetic environment.  I am an elegant, patient, humble and calm individual.",
    icon: require("@/assets/images/icons/personality-icons/Calming Presence.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Calming Presence.png"),
    id: "calming-influence",
    personalityMapId: 17,
  },
  {
    title: "Conflict Confronter",
    tagline: "Willing to speak out and even challenge the status quo.",
    ability: "Confronting Conflicts",
    description:
      "Handle and resolve conflict promptly; confronting underperformance quickly when individuals fail to meet expectations, taking corrective action. Challenge the status quo, even at personal risk, willing to speak out.",
    iAmDescription:
      "Known to handle and resolve conflicts as a Conflict Confronter. An honest and the outspoken person.",
    icon: require("@/assets/images/icons/personality-icons/Conflict Confronter.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Conflict Confronter.png"),
    id: "conflict-confronter",
    personalityMapId: 7,
  },
  {
    title: "Compassionate Carer",
    tagline:
      "The altruist, moved by compassion, generosity and a desire to help others.",
    ability: "Compassion and Care",
    description:
      "Being friendly and easy to approach; demonstrate genuine concern for an interest in others; listening with an interest in understanding the thoughts and feelings of others.",
    iAmDescription:
      "Considered to be a Considerate Carer, I am moved by compassion with a desire to help others. Extremely perceptive of other’s feelings and get along well with others in team.",
    icon: require("@/assets/images/icons/personality-icons/Considerate Career.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Considerate Carer.png"),
    id: "compassionate-carer",
    personalityMapId: 16,
  },
  {
    title: "Constant Learner",
    tagline: "Good general knowledge with life skills in their arsenal.",
    ability: "Learning Continuously",
    description:
      "Continuously develop new skills and enhance existing capabilities; having a good general knowledge and making an effort to stay up to date with current affairs; have the functional and technical knowledge with skills to get the job done.",
    iAmDescription:
      "As a Constant Learner, I am passionately curious and inquisitive. Good general knowledge with life skills to my advantage.",
    icon: require("@/assets/images/icons/personality-icons/Constant Learner.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Constant Learner.png"),
    id: "constant-learner",
    personalityMapId: 4,
  },
  {
    title: "Energetic Driver",
    tagline: "Result oriented. Demonstrates a positive can-do attitude",
    ability: "Enthusiasm and Drive",
    description:
      "Consistently achieving results and meeting goals and targets; being motivated to achieve career advancement; stick to a course of action despite obstacles and seeing things through to the end; taking initiative and demonstrate a positive can-do attitude.",
    iAmDescription:
      "I am a Result oriented person, demonstrating a positive can-do attitude at work with an Energetic Spirit. Enthusiastic, idealistic, and creative.",
    icon: require("@/assets/images/icons/personality-icons/Energetic Driver.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Energetic Driver.png"),
    id: "energetic-driver",
    personalityMapId: 1,
  },
  {
    title: "Flexible Character",
    tagline:
      "Self-aware. Adapts behaviour to the interpersonal style and needs of others.",
    ability: "Flexibility",
    description:
      "Adapting behaviour to the interpersonal style and needs of others; is open to feedback and aware of strengths and weaknesses.",
    iAmDescription:
      "I am a Flexible Character. I am able to adapt to the interpersonal style and needs of others. I am aware of myself known to be original and creative.",
    icon: require("@/assets/images/icons/personality-icons/Flexible Character.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Flexible Character.png"),
    id: "flexible-character",
    personalityMapId: 2,
  },
  {
    title: "Willing Risk Taker",
    tagline:
      "Interacts with others confidently; is tactful and can communicate in a non-confrontational and polite manner",
    ability: "Risk Taking",
    description:
      "Comfortable working in a changing and uncertain environment; enjoy trying new things and is willing to experiment, taking calculated risks.",
    iAmDescription:
      "I am a Willing Risk Taker who accepts uncertainty of life and matters. I enjoy trying new things and am willing to experiment and take calculated risks.​",
    icon: require("@/assets/images/icons/personality-icons/Willing Risk Taker.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Willing Risk Taker.png"),
    id: "willing-risk-taker",
    personalityMapId: 5,
  },
  {
    title: "Imaginative Mind",
    tagline:
      "Creative and innovative with work and life. Ideas are always flickering in the bulb over the head.",
    ability: "Imagination",
    description:
      "Creating new ideas by seeing new connections between different and sometimes unrelated concepts; being open to different and sometimes conflicting ideas or concepts and willing to change accordingly.",
    iAmDescription:
      "An Imaginative Mind with a logical, original and creative thoughtful work and life. Ideas are always flickering in the bulb over my head.​",
    icon: require("@/assets/images/icons/personality-icons/Imaginative Mind.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Imaginative Mind.png"),
    id: "imaginative-mind",
    personalityMapId: 3,
  },
  {
    title: "Inspirational Motivator",
    tagline: "Inspirational and the opposite virtues of being ordinary.",
    ability: "Motivational Influence",
    description:
      "Inspiring others to accept and trust a vision of the future; knowing what motivates different types of people and get the best out of them; developing others and providing an opportunity for them to practice new skills or improve existing ones; ability to pull people together as a team for a common purpose.",
    iAmDescription:
      "Inspirational & Cheerful and the opposite virtues of being ordinary. I am known to inspire others to accept and trust a vision of the future with a well-developed wit.",
    icon: require("@/assets/images/icons/personality-icons/Inspirational Motivator.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Inspirational Motivator.png"),
    id: "inspirational-motivator",
    personalityMapId: 12,
  },
  {
    title: "Effective Negotiator",
    tagline: "Goals, plans and attention to detail.",
    ability: "Negotiating Effectively",
    description:
      "Interacting with others confidently; communicating in a tactful, non-confrontational and polite manner; reaching win-win outcomes even when there are conflicting interests and limited resources; knowing how to manage the politics of relationships.",
    iAmDescription:
      "As an Effective Negotiator, I am confident, tactful and know the respectful of relationships. Known to reach win-win outcomes even when there are conflicting interests and limited resources.",
    icon: require("@/assets/images/icons/personality-icons/Effective Negotiator.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Effective Negotiator.png"),
    id: "effective-negotiator",
    personalityMapId: 13,
  },
  {
    title: "People Leader",
    tagline: "Helping you be you (only better)",
    ability: "Leadership",
    description:
      "Providing clear objectives and instructions to others; assigning meaningful and important tasks and responsibilities to others and giving them authority to act; putting useful and meaningful measures in place to monitor work processes.",
    iAmDescription:
      "As a People Manager, with an encouraging attitude. I am extremely intuitive about people, and concerned for their feelings.",
    icon: require("@/assets/images/icons/personality-icons/People Manager.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/People Manager.png"),
    id: "people-leader",
    personalityMapId: 10,
  },
  {
    title: "Practical Fixer",
    tagline:
      "The go-to person. Continuously improving and solving challenging problems.",
    ability: "Practical Solutions",
    description:
      "Always looking for ways to improve processes; taking new ideas from concept to reality by managing the innovation process; solving challenging problems by using a combination of intuition and analytical thinking; quickly realizing the impact new technology and finding opportunities to integrate it.",
    iAmDescription:
      "I am generally the Practical Fixer, the go-to person. Continuously improving and solving challenging problems.",
    icon: require("@/assets/images/icons/personality-icons/Practical Fixer.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Practical Fixer.png"),
    id: "practical-fixer",
    personalityMapId: 15,
  },
  {
    title: "Responsible Citizen",
    tagline: "Trustworthy with a high moral and ethics",
    ability: "Trust and Responsibility",
    description:
      "Acting ethically; treating people fairly regardless of race, gender, cultural differences; accepting accountability for personal actions; being considered trustworthy by others.",
    iAmDescription:
      "Trustworthy with a high moral and ethics carrying traits of Responsible Person. I am known to be well-organised and hardworking, and work steadily towards identified goals.",
    icon: require("@/assets/images/icons/personality-icons/Responsible Citizen.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Responsible Citizen.png"),
    id: "responsible-citizen",
    personalityMapId: 18,
  },
  {
    title: "Skilled Communicator",
    tagline: "Sharing wisdom with you with an ability to explain.",
    ability: "Communication Skills",
    description:
      "Clearly explaining a point of view and its reasoning in both one-on-one and large audience situations; writing accurately and professionally in multiple formats, with the correct amount of detail; keeping people informed with relevant and well-timed information.",
    iAmDescription:
      "As a Skilled Communicator I carry an ability to explain. I am comfortable with self-expression, fostering healthy teams.​",
    icon: require("@/assets/images/icons/personality-icons/Skilled Communicator.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Skilled Communicator.png"),
    id: "skilled-communicator",
    personalityMapId: 14,
  },
  {
    title: "Methodical Organizer",
    tagline:
      "Interacts with others confidently; is tactful and can communicate in a non-confrontational and polite manner",
    ability: "Methodical Organization",
    description:
      "Being well organized and methodical, paying attention to detail; having a high level of productivity and using time well to get work done; setting definite milestones and actions for achieving goals.",
    iAmDescription:
      "Goals, plans and attention to detail come naturally to me. I am a Methodical Organizer with high standards of performance.",
    icon: require("@/assets/images/icons/personality-icons/Methodical Organiser.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Methodical Organiser.png"),
    id: "methodical-organizer",
    personalityMapId: 8,
  },
  {
    title: "Social Networker",
    tagline: "Open personality, social and easy to mingle with.",
    ability: "Networking Socially",
    description:
      "Cooperating well with others; delivering great service to customers, with a focus on their needs; actively building and managing social networks; sharing an appropriate amount of personal information so that others can get to know you; working effectively with people in authority.",
    iAmDescription:
      "Open personality, social and easy to mingle with as a Social Networker. I probably place the needs of others over my own needs.",
    icon: require("@/assets/images/icons/personality-icons/Social Networker.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Social Networker.png"),
    id: "social-networker",
    personalityMapId: 11,
  },
  {
    title: "Sound Decision Maker",
    tagline: "Experienced, exercises good judgment when making decisions.",
    ability: "Decision Making",
    description:
      "Making decisions, even in the absence of complete data; exercising good judgment when making decisions while taking into account both facts and personal experience; prioritizing between critical and less important tasks; accurately identifying strengths, weaknesses and potential in people with relatively short exposure to them.",
    iAmDescription:
      "Experienced to understand and exercise a good judgment as a Sound Decision Maker. Known to be creative, resourceful, and intellectually quick.",
    icon: require("@/assets/images/icons/personality-icons/Sound Decision Maker.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Sound Decision Maker.png"),
    id: "sound-decision-maker",
    personalityMapId: 9,
  },
];

// DPD Belux Personality Traits
const dpdBeluxPersonalityTraits_en = [
  {
    title: "Evaluate goals and performance against strategic plan",
    tagline:
      "Identifies how internal and external influences and trends impact goals and priorities that are related to the strategic plan.",
    icon: require("@/assets/images/icons/personality-icons/Big Picture Thinker.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Big Picture Thinker.png"),
    id: "evaluate-goals-and-performance-against-strategic-plan",
    alexCompetencyMapId: 24,
  },
  {
    title: "Integrates diverse views",
    tagline: "Facilitates breakthroughs by integrating diverse views.",
    icon: require("@/assets/images/icons/personality-icons/Calming Presence.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Calming Presence.png"),
    id: "integrates-diverse-views",
    alexCompetencyMapId: 35,
  },
  {
    title: "Handles high tension situations",
    tagline: "Defuses high-tension situations effectively.",
    icon: require("@/assets/images/icons/personality-icons/Conflict Confronter.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Conflict Confronter.png"),
    id: "Handles-high-tension-situations",
    alexCompetencyMapId: 25,
  },
  {
    title: "Works cooperatively",
    tagline:
      "Works cooperatively with others across the organization to achieve shared objectives.",
    icon: require("@/assets/images/icons/personality-icons/Considerate Career.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Considerate Carer.png"),
    id: "works-cooperatively",
    alexCompetencyMapId: 34,
  },
  {
    title: "Customer Focused",
    tagline:
      "Approaches new situations at work with a positive attitude while working towards planned goals.",
    icon: require("@/assets/images/icons/personality-icons/Constant Learner.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Constant Learner.png"),
    id: "customer-focused",
    alexCompetencyMapId: 22,
  },
  {
    title: "Willing to make mistakes",
    tagline:
      "Open and receptive to being wrong and acknowledge mistakes. Speaks up in the face of injustice even at a personal risk.",
    icon: require("@/assets/images/icons/personality-icons/Energetic Driver.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Energetic Driver.png"),
    id: "willing-to-make-mistakes",
    alexCompetencyMapId: 19,
  },
  {
    title: "Adapts to the environment",
    tagline: "Readily adapts personal, interpersonal and leadership behavior",
    icon: require("@/assets/images/icons/personality-icons/Flexible Character.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Flexible Character.png"),
    id: "adapts-to-the-environment",
    alexCompetencyMapId: 20,
  },
  {
    title: "Formulates a competitive strategy",
    tagline:
      "Sees the bigger picture, constantly imagines future scenarios and creates strategies to sustain competitive advantage.",
    icon: require("@/assets/images/icons/personality-icons/Willing Risk Taker.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Willing Risk Taker.png"),
    id: "formulates-a-competitive-strategy",
    alexCompetencyMapId: 23,
  },
  {
    title: "Prioritizes effectively",
    tagline: "Shifts priorities in response to the demands of a situation.",
    icon: require("@/assets/images/icons/personality-icons/Imaginative Mind.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Imaginative Mind.png"),
    id: "prioritizes-effectively",
    alexCompetencyMapId: 21,
  },
  {
    title: "Champions ideas",
    tagline:
      "Willing to champion an idea or position despite dissent or political risk.",
    icon: require("@/assets/images/icons/personality-icons/Inspirational Motivator.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Inspirational Motivator.png"),
    id: "Champions ideas",
    alexCompetencyMapId: 30,
  },
  {
    title: "Encourages engagement from all stakeholders",
    tagline:
      "Asks questions and listens closely to all issues presented by stakeholders.",
    icon: require("@/assets/images/icons/personality-icons/Effective Negotiator.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Effective Negotiator.png"),
    id: "encourages-engagement-from-all-stakeholders",
    alexCompetencyMapId: 31,
  },
  {
    title: "Effectively manages from a distance",
    tagline:
      "Designs processes and procedures that allow managing from a distance.",
    icon: require("@/assets/images/icons/personality-icons/People Manager.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/People Manager.png"),
    id: "effectively-manages-from-a-distance",
    alexCompetencyMapId: 28,
  },
  {
    title: "Improves the quality of work processes",
    tagline:
      "Ensure areas for improvement are identified and addressed even if it challenges the status quo.",
    icon: require("@/assets/images/icons/personality-icons/Practical Fixer.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Practical Fixer.png"),
    id: "improves-the-quality-of-work-processes",
    alexCompetencyMapId: 33,
  },
  {
    title: "Creates sustainable value",
    tagline:
      "Articulates credible pictures and visions of possibilities that will create sustainable value.",
    icon: require("@/assets/images/icons/personality-icons/Responsible Citizen.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Responsible Citizen.png"),
    id: "creates-sustainable-value",
    alexCompetencyMapId: 36,
  },
  {
    title: "Shares information",
    tagline:
      "Shares information openly with others in their department (and out of it).",
    icon: require("@/assets/images/icons/personality-icons/Skilled Communicator.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Skilled Communicator.png"),
    id: "shares-information",
    alexCompetencyMapId: 32,
  },
  {
    title: "Seizes development opportunities",
    tagline: "Identifies and seizes opportunities for synergy and integration.",
    icon: require("@/assets/images/icons/personality-icons/Methodical Organiser.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Methodical Organiser.png"),
    id: "seizes-development-opportunities",
    alexCompetencyMapId: 26,
  },
  {
    title: "Proactive",
    tagline:
      "Proactively finds opportunities to work collaboratively with others.",
    icon: require("@/assets/images/icons/personality-icons/Social Networker.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Social Networker.png"),
    id: "proactive",
    alexCompetencyMapId: 29,
  },
  {
    title: "Takes decisions",
    tagline:
      "Able to take an unpopular decision for the greater good of the company.",
    icon: require("@/assets/images/icons/personality-icons/Sound Decision Maker.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Sound Decision Maker.png"),
    id: "takes-decisions",
    alexCompetencyMapId: 27,
  },
];

// Gala Personality Traits
const galaPersonalityTraits_en = [
  {
    title: "Confronting Conflicts",
    tagline: "Willing to speak out and even challenge the status quo.",
    ability: "Confronting Conflicts",
    description:
      "Handle and resolve conflict promptly; confronting underperformance quickly when individuals fail to meet expectations, taking corrective action. Challenge the status quo, even at personal risk, willing to speak out.",
    iAmDescription:
      "Known to handle and resolve conflicts as a Conflict Confronter. An honest and the outspoken person.",
    icon: require("@/assets/images/icons/personality-icons-gala/conflict-confronter.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons-gala/personality-png/conflict-confronter.png"),
    id: "conflict-confronter",
    personalityMapId: 37,
    background: "rgba(113, 64, 255, 0.1)!important",
    characterType: "strength",
    border: "1px solid #D8D5D5",
  },
  {
    title: "Networking Socially",
    tagline: "Open personality, social and easy to mingle with.",
    ability: "Networking Socially",
    description:
      "Cooperating well with others; delivering great service to customers, with a focus on their needs; actively building and managing social networks; sharing an appropriate amount of personal information so that others can get to know you; working effectively with people in authority.",
    iAmDescription:
      "Open personality, social and easy to mingle with as a Social Networker. I probably place the needs of others over my own needs.",
    icon: require("@/assets/images/icons/personality-icons-gala/social-networker.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons-gala/personality-png/social-networker.png"),
    id: "social-networker",
    personalityMapId: 38,
    background: "rgba(220, 0, 50, 0.1)!important",
    characterType: "charisma",
    border: "1px solid #D8D5D5",
  },
  {
    title: "Communication Skills",
    tagline: "Sharing wisdom with you with an ability to explain.",
    ability: "Communication Skills",
    description:
      "Clearly explaining a point of view and its reasoning in both one-on-one and large audience situations; writing accurately and professionally in multiple formats, with the correct amount of detail; keeping people informed with relevant and well-timed information.",
    iAmDescription:
      "As a Skilled Communicator I carry an ability to explain. I am comfortable with self-expression, fostering healthy teams.​",
    icon: require("@/assets/images/icons/personality-icons-gala/skilled-communicator.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons-gala/personality-png/skilled-communicator.png"),
    id: "skilled-communicator",
    personalityMapId: 39,
    background: "rgba(220, 0, 47, 0.1)!important",
    characterType: "charisma",
    border: "1px solid #D8D5D5",
  },
  {
    title: "Compassion and Care",
    tagline:
      "The altruist, moved by compassion, generosity and a desire to help others.",
    ability: "Compassion and Care",
    description:
      "Being friendly and easy to approach; demonstrate genuine concern for an interest in others; listening with an interest in understanding the thoughts and feelings of others.",
    iAmDescription:
      "Considered to be a Considerate Carer, I am moved by compassion with a desire to help others. Extremely perceptive of other’s feelings and get along well with others in team.",
    icon: require("@/assets/images/icons/personality-icons-gala/compassionate-carer.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons-gala/personality-png/compassionate-carer.png"),
    id: "compassionate-carer",
    personalityMapId: 40,
    background: "rgba(255, 123, 145, 0.1)!important",
    characterType: "compassion",
    border: "1px solid #D8D5D5",
  },
  {
    title: "Trust and Responsibility",
    tagline: "Trustworthy with a high moral and ethics",
    ability: "Trust and Responsibility",
    description:
      "Acting ethically; treating people fairly regardless of race, gender, cultural differences; accepting accountability for personal actions; being considered trustworthy by others.",
    iAmDescription:
      "Trustworthy with a high moral and ethics carrying traits of Responsible Person. I am known to be well-organised and hardworking, and work steadily towards identified goals.",
    icon: require("@/assets/images/icons/personality-icons-gala/responsible-citizen.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons-gala/personality-png/responsible-citizen.png"),
    id: "responsible-citizen",
    personalityMapId: 41,
    background: "rgba(255, 123, 145, 0.1)!important",
    characterType: "compassion",
    border: "1px solid #D8D5D5",
  },
  {
    title: "Methodical Organization",
    tagline:
      "Interacts with others confidently; is tactful and can communicate in a non-confrontational and polite manner",
    ability: "Methodical Organization",
    description:
      "Being well organized and methodical, paying attention to detail; having a high level of productivity and using time well to get work done; setting definite milestones and actions for achieving goals.",
    iAmDescription:
      "Goals, plans and attention to detail come naturally to me. I am a Methodical Organizer with high standards of performance.",
    icon: require("@/assets/images/icons/personality-icons-gala/methodical-organiser.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons-gala/personality-png/methodical-organizer.png"),
    id: "methodical-organizer",
    personalityMapId: 42,
    background: "rgba(68, 204, 136, 0.1)!important",
    characterType: "dexterity",
    border: "1px solid #D8D5D5",
  },
  {
    title: "Motivational Influence",
    tagline: "Inspirational and the opposite virtues of being ordinary.",
    ability: "Motivational Influence",
    description:
      "Inspiring others to accept and trust a vision of the future; knowing what motivates different types of people and get the best out of them; developing others and providing an opportunity for them to practice new skills or improve existing ones; ability to pull people together as a team for a common purpose.",
    iAmDescription:
      "Inspirational & Cheerful and the opposite virtues of being ordinary. I am known to inspire others to accept and trust a vision of the future with a well-developed wit.",
    icon: require("@/assets/images/icons/personality-icons-gala/inspirational-motivator.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons-gala/personality-png/inspirational-motivator.png"),
    id: "inspirational-motivator",
    personalityMapId: 43,
    background: "rgba(196, 20, 50, 0.1)!important",
    characterType: "charisma",
    border: "1px solid #D8D5D5",
  },
  {
    title: "Calming Influence",
    tagline: "Elegant. Patient, humble and calm under pressure",
    ability: "Calming Influence",
    description:
      "Remaining calm under pressure; recognizing the contribution of others and acts humbly about strengths and achievements; being patient with people and knowing when to slow down to let others catch up; balancing work and personal priorities.",
    iAmDescription:
      "Calming Influence in the midst of a highly energetic environment.  I am an elegant, patient, humble and calm individual.",
    icon: require("@/assets/images/icons/personality-icons-gala/calming-influence.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons-gala/personality-png/calming-influence.png"),
    id: "calming-influence",
    personalityMapId: 44,
    background: "rgba(255, 123, 145, 0.1)!important",
    characterType: "compassion",
    border: "1px solid #D8D5D5",
  },
  {
    title: "Practical Solutions",
    tagline:
      "The go-to person. Continuously improving and solving challenging problems.",
    ability: "Practical Solutions",
    description:
      "Always looking for ways to improve processes; taking new ideas from concept to reality by managing the innovation process; solving challenging problems by using a combination of intuition and analytical thinking; quickly realizing the impact new technology and finding opportunities to integrate it.",
    iAmDescription:
      "I am generally the Practical Fixer, the go-to person. Continuously improving and solving challenging problems.",
    icon: require("@/assets/images/icons/personality-icons-gala/practical-fixer.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons-gala/personality-png/practical-fixer.png"),
    id: "practical-fixer",
    personalityMapId: 45,
    background: "rgba(68, 204, 136, 0.1)!important",
    characterType: "dexterity",
    border: "1px solid #D8D5D5",
  },
  {
    title: "Learning Continuously",
    tagline: "Good general knowledge with life skills in their arsenal.",
    ability: "Learning Continuously",
    description:
      "Continuously develop new skills and enhance existing capabilities; having a good general knowledge and making an effort to stay up to date with current affairs; have the functional and technical knowledge with skills to get the job done.",
    iAmDescription:
      "As a Constant Learner, I am passionately curious and inquisitive. Good general knowledge with life skills to my advantage.",
    icon: require("@/assets/images/icons/personality-icons-gala/constant-learner.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons-gala/personality-png/constant-learner.png"),
    id: "constant-learner",
    personalityMapId: 46,
    background: "rgba(103, 216, 243, 0.1)!important",
    characterType: "intelligence",
    border: "1px solid #D8D5D5",
  },
  {
    title: "Flexibility",
    tagline:
      "Self-aware. Adapts behaviour to the interpersonal style and needs of others.",
    ability: "Flexibility",
    description:
      "Adapting behaviour to the interpersonal style and needs of others; is open to feedback and aware of strengths and weaknesses.",
    iAmDescription:
      "I am a Flexible Character. I am able to adapt to the interpersonal style and needs of others. I am aware of myself known to be original and creative.",
    icon: require("@/assets/images/icons/personality-icons-gala/flexible-character.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons-gala/personality-png/flexible-character.png"),
    id: "flexible-character",
    personalityMapId: 47,
    background: "rgba(68, 204, 136, 0.1)!important",
    characterType: "dexterity",
    border: "1px solid #D8D5D5",
  },
  {
    title: "Thinking Big",
    tagline: "Intuitive, cognitive and caters to a broader perspective.",
    ability: "Thinking Big",
    description:
      "Shifting focus away from the details and gain a broader perspective; envisioning future scenarios based on a combination of intuition, trends and data; dealing with complex intellectual and cognitive concepts.",
    iAmDescription:
      "I am a Big Picture Thinker with an intuitive and cognitive mind that caters to a broader perspective. Exceptionally capable in organising and running activities and projects.",
    icon: require("@/assets/images/icons/personality-icons-gala/big-picture-thinker.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons-gala/personality-png/big-picture-thinker.png"),
    id: "big-picture-thinker",
    personalityMapId: 48,
    background: "rgba(103, 216, 243, 0.1)!important",
    characterType: "intelligence",
    border: "1px solid #D8D5D5",
  },
  {
    title: "Negotiating Effectively",
    tagline: "Goals, plans and attention to detail.",
    ability: "Negotiating Effectively",
    description:
      "Interacting with others confidently; communicating in a tactful, non-confrontational and polite manner; reaching win-win outcomes even when there are conflicting interests and limited resources; knowing how to manage the politics of relationships.",
    iAmDescription:
      "As an Effective Negotiator, I am confident, tactful and know the respectful of relationships. Known to reach win-win outcomes even when there are conflicting interests and limited resources.",
    icon: require("@/assets/images/icons/personality-icons-gala/effective-negotiator.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons-gala/personality-png/effective-negotiator.png"),
    id: "effective-negotiator",
    personalityMapId: 49,
    background: "rgba(242, 147, 0, 0.1)!important",
    characterType: "wisdom",
    border: "1px solid #D8D5D5",
  },
  {
    title: "Decision Making",
    tagline: "Experienced, exercises good judgment when making decisions.",
    ability: "Decision Making",
    description:
      "Making decisions, even in the absence of complete data; exercising good judgment when making decisions while taking into account both facts and personal experience; prioritizing between critical and less important tasks; accurately identifying strengths, weaknesses and potential in people with relatively short exposure to them.",
    iAmDescription:
      "Experienced to understand and exercise a good judgment as a Sound Decision Maker. Known to be creative, resourceful, and intellectually quick.",
    icon: require("@/assets/images/icons/personality-icons-gala/sound-decision-maker.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons-gala/personality-png/sound-decision-maker.png"),
    id: "sound-decision-maker",
    personalityMapId: 50,
    background: "rgba(242, 147, 0, 0.1)!important",
    characterType: "wisdom",
    border: "1px solid #D8D5D5",
  },
  {
    title: "Leadership",
    tagline: "Helping you be you (only better)",
    ability: "Leadership",
    description:
      "Providing clear objectives and instructions to others; assigning meaningful and important tasks and responsibilities to others and giving them authority to act; putting useful and meaningful measures in place to monitor work processes.",
    iAmDescription:
      "As a People Manager, with an encouraging attitude. I am extremely intuitive about people, and concerned for their feelings.",
    icon: require("@/assets/images/icons/personality-icons-gala/people-leader.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons-gala/personality-png/people-leader.png"),
    id: "people-leader",
    personalityMapId: 51,
    background: "rgba(242, 147, 0, 0.1)!important",
    characterType: "wisdom",
    border: "1px solid #D8D5D5",
  },
  {
    title: "Risk Taking",
    tagline:
      "Interacts with others confidently; is tactful and can communicate in a non-confrontational and polite manner",
    ability: "Risk Taking",
    description:
      "Comfortable working in a changing and uncertain environment; enjoy trying new things and is willing to experiment, taking calculated risks.",
    iAmDescription:
      "I am a Willing Risk Taker who accepts uncertainty of life and matters. I enjoy trying new things and am willing to experiment and take calculated risks.​",
    icon: require("@/assets/images/icons/personality-icons-gala/willing-risk-taker.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons-gala/personality-png/willing-risk-taker.png"),
    id: "willing-risk-taker",
    personalityMapId: 52,
    background: "rgba(113, 64, 255, 0.1)!important",
    characterType: "strength",
    border: "1px solid #D8D5D5",
  },
  {
    title: "Enthusiasm and Drive",
    tagline: "Result oriented. Demonstrates a positive can-do attitude",
    ability: "Enthusiasm and Drive",
    description:
      "Consistently achieving results and meeting goals and targets; being motivated to achieve career advancement; stick to a course of action despite obstacles and seeing things through to the end; taking initiative and demonstrate a positive can-do attitude.",
    iAmDescription:
      "I am a Result oriented person, demonstrating a positive can-do attitude at work with an Energetic Spirit. Enthusiastic, idealistic, and creative.",
    icon: require("@/assets/images/icons/personality-icons-gala/energetic-driver.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons-gala/personality-png/energetic-driver.png"),
    id: "energetic-driver",
    personalityMapId: 53,
    background: "rgba(113, 64, 255, 0.1)!important",
    characterType: "strength",
    border: "1px solid #D8D5D5",
  },
  {
    title: "Imagination",
    tagline:
      "Creative and innovative with work and life. Ideas are always flickering in the bulb over the head.",
    ability: "Imagination",
    description:
      "Creating new ideas by seeing new connections between different and sometimes unrelated concepts; being open to different and sometimes conflicting ideas or concepts and willing to change accordingly.",
    iAmDescription:
      "An Imaginative Mind with a logical, original and creative thoughtful work and life. Ideas are always flickering in the bulb over my head.​",
    icon: require("@/assets/images/icons/personality-icons-gala/imaginative-mind.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons-gala/personality-png/imaginative-mind.png"),
    id: "imaginative-mind",
    personalityMapId: 54,
    background: "rgba(103, 216, 243, 0.1)!important",
    characterType: "intelligence",
    border: "1px solid #D8D5D5",
  },
];

// Personality Traits Espanish
const defaultPersonalityTraits_es = [
  {
    title: "Piensa estratégicamente",
    tagline: "Intuitivo, cognitivo y abastece a una perspectiva más amplia.",
    iAmDescription:
      "Soy un pensador del panorama general con una mente intuitiva y cognitiva que se adapta a una perspectiva más amplia. Excepcionalmente capaz de organizar y ejecutar actividades y proyectos.",
    icon: require("@/assets/images/icons/personality-icons/Big Picture Thinker.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Big Picture Thinker.png"),
    id: "big-picture-thinker",
    personalityMapId: 6,
  },
  {
    title: "Mantiene la calma bajo presión",
    tagline: "Elegante. Paciente, humilde y tranquilo bajo presión",
    iAmDescription:
      "Influencia calmante en medio de un ambiente de alta energía. Soy una persona elegante, paciente, humilde y tranquila.",
    icon: require("@/assets/images/icons/personality-icons/Calming Presence.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Calming Presence.png"),
    id: "calming-influence",
    personalityMapId: 17,
  },
  {
    title: "Afronta el conflicto",
    tagline: "Dispuestos a hablar e incluso desafiar el status quo.",
    iAmDescription:
      "Conocido por manejar y resolver conflictos como un enfrentador de conflictos. Una persona honesta y franca.",
    icon: require("@/assets/images/icons/personality-icons/Conflict Confronter.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Conflict Confronter.png"),
    id: "conflict-confronter",
    personalityMapId: 7,
  },
  {
    title: "Se preocupa por los demás",
    tagline:
      "El altruista, movido por la compasión, la generosidad y el deseo de ayudar a los demás.",
    iAmDescription:
      "Considerado un cuidador compasivo, me mueve la compasión con el deseo de ayudar a los demás. Extremadamente perceptivo de los sentimientos de los demás y se lleva bien con los demás en el equipo.",
    icon: require("@/assets/images/icons/personality-icons/Considerate Career.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Considerate Carer.png"),
    id: "compassionate-carer",
    personalityMapId: 16,
  },
  {
    title: "Aprende constantemente",
    tagline:
      "Buen conocimiento general con habilidades para la vida en su arsenal.",
    iAmDescription:
      "Como aprendiz constante, soy apasionadamente curioso e inquisitivo. Buen conocimiento general con habilidades para la vida a mi favor.",
    icon: require("@/assets/images/icons/personality-icons/Constant Learner.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Constant Learner.png"),
    id: "constant-learner",
    personalityMapId: 4,
  },
  {
    title: "Es energético/a",
    tagline:
      "Orientado a los resultados. Demuestra una actitud positiva de poder hacer",
    iAmDescription:
      "Soy una persona orientada a resultados, demostrando una actitud positiva de poder hacer en el trabajo con un espíritu enérgico. Entusiasta, idealista y creativa.",
    icon: require("@/assets/images/icons/personality-icons/Energetic Driver.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Energetic Driver.png"),
    id: "energetic-driver",
    personalityMapId: 1,
  },
  {
    title: "Es flexible",
    tagline:
      "Autoconsciente. Adapta el comportamiento al estilo interpersonal y las necesidades de los demás.",
    iAmDescription:
      "Soy un personaje flexible. Soy capaz de adaptarme al estilo interpersonal y las necesidades de los demás. Soy consciente de mí mismo conocido por ser original y creativo.",
    icon: require("@/assets/images/icons/personality-icons/Flexible Character.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Flexible Character.png"),
    id: "flexible-character",
    personalityMapId: 2,
  },
  {
    title: "Toma riesgos",
    tagline:
      "Interactúa con otros con confianza; tiene tacto y puede comunicarse de una manera educada y sin confrontaciones",
    iAmDescription:
      "Soy un tomador de riesgos dispuesto que acepta la incertidumbre de la vida y las cosas. Disfruto probando cosas nuevas y estoy dispuesto a experimentar y tomar riesgos calculados.",
    icon: require("@/assets/images/icons/personality-icons/Willing Risk Taker.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Willing Risk Taker.png"),
    id: "willing-risk-taker",
    personalityMapId: 6,
  },
  {
    title: "Es creativo/a",
    tagline:
      "Creativo e innovador con el trabajo y la vida. Las ideas siempre están parpadeando en la bombilla sobre la cabeza.",
    iAmDescription:
      "Una mente imaginativa con un trabajo y una vida reflexivos, lógicos, originales y creativos. Las ideas siempre están parpadeando en la bombilla sobre mi cabeza.​",
    icon: require("@/assets/images/icons/personality-icons/Imaginative Mind.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Imaginative Mind.png"),
    id: "imaginative-mind",
    personalityMapId: 3,
  },
  {
    title: "Inspira y motiva",
    tagline: "Inspiradoras y las virtudes opuestas de ser ordinario.",
    iAmDescription:
      "Inspirador y alegre y las virtudes opuestas de ser ordinario. Se me conoce por inspirar a otros a aceptar y confiar en una visión del futuro con un ingenio bien desarrollado.",
    icon: require("@/assets/images/icons/personality-icons/Inspirational Motivator.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Inspirational Motivator.png"),
    id: "inspirational-motivator",
    personalityMapId: 12,
  },
  {
    title: "Es diplomático/a",
    tagline: "Metas, planes y atención al detalle.",
    iAmDescription:
      "Como negociador eficaz, tengo confianza, tengo tacto y conozco el respeto de las relaciones. Conocido por alcanzar resultados beneficiosos para todos, incluso cuando existen intereses en conflicto y recursos limitados.",
    icon: require("@/assets/images/icons/personality-icons/Effective Negotiator.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Effective Negotiator.png"),
    id: "effective-negotiator",
    personalityMapId: 13,
  },
  {
    title: "Gestiona a otras personas",
    tagline: "Ayudándote a ser tú (solo que mejor)",
    iAmDescription:
      "Como Gerente de Personas, con actitud alentadora. Soy extremadamente intuitivo con las personas y me preocupo por sus sentimientos.",
    icon: require("@/assets/images/icons/personality-icons/People Manager.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/People Manager.png"),
    id: "people-leader",
    personalityMapId: 10,
  },
  {
    title: "Resuelve problemas",
    tagline:
      "La persona a la que acudir. Mejorando y resolviendo problemas desafiantes continuamente.",
    iAmDescription:
      "Por lo general, soy el reparador práctico, la persona a la que se debe acudir. Mejorando y resolviendo problemas desafiantes continuamente.",
    icon: require("@/assets/images/icons/personality-icons/Practical Fixer.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Practical Fixer.png"),
    id: "practical-fixer",
    personalityMapId: 15,
  },
  {
    title: "Es responsable y ético/a",
    tagline: "Confiable con una alta moral y ética.",
    iAmDescription:
      "Confiable con una alta moral y ética con rasgos de Persona Responsable. Se me conoce por ser bien organizado y trabajador, y trabajo de manera constante hacia los objetivos identificados.",
    icon: require("@/assets/images/icons/personality-icons/Responsible Citizen.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Responsible Citizen.png"),
    id: "responsible-citizen",
    personalityMapId: 18,
  },
  {
    title: "Se comunica bien",
    tagline: "Compartiendo sabiduría contigo con la habilidad de explicar.",
    iAmDescription:
      "Como comunicadora experta, tengo la capacidad de explicar. Me siento cómodo con la autoexpresión, fomentando equipos saludables.",
    icon: require("@/assets/images/icons/personality-icons/Skilled Communicator.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Skilled Communicator.png"),
    id: "skilled-communicator",
    personalityMapId: 14,
  },
  {
    title: "Es organizado/a",
    tagline:
      "Interactúa con otros con confianza; tiene tacto y puede comunicarse de una manera educada y sin confrontaciones",
    iAmDescription:
      "Me resultan naturales los objetivos, los planes y la atención al detalle. Soy un organizador metódico con altos estándares de desempeño.",
    icon: require("@/assets/images/icons/personality-icons/Methodical Organiser.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Methodical Organiser.png"),
    id: "methodical-organizer",
    personalityMapId: 8,
  },
  {
    title: "Crea conexiones sociales",
    tagline: "Personalidad abierta, social y fácil de relacionarse.",
    iAmDescription:
      "Personalidad abierta, social y fácil de relacionarse como miembro de la red social. Probablemente coloque las necesidades de los demás por encima de las mías.",
    icon: require("@/assets/images/icons/personality-icons/Social Networker.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Social Networker.png"),
    id: "social-networker",
    personalityMapId: 11,
  },
  {
    title: "Toma buenas decisiones",
    tagline: "Experimentado, ejerce buen juicio al tomar decisiones.",
    iAmDescription:
      "Experimentado para comprender y ejercer un buen juicio como un tomador de decisiones acertado. Conocido por ser creativo, ingenioso e intelectualmente rápido.",
    icon: require("@/assets/images/icons/personality-icons/Sound Decision Maker.svg"),
    pngIcon: require("@/assets/images/icons/personality-icons/personality-png/Sound Decision Maker.png"),
    id: "sound-decision-maker",
    personalityMapId: 9,
  },
];

module.exports = {
  defaultPersonalityTraits_en,
  defaultPersonalityTraits_es,
  dpdBeluxPersonalityTraits_en,
  galaPersonalityTraits_en,
};
